import React from 'react';
import homeloan from '../Asserts/homeloan.png';
import personalloan from "../Asserts/personalloan.png";
import lifeinsurance from "../Asserts/lifeinsurnace.png";
import healthinsurance from "../Asserts/healthinsurnace.png";
import personalloan2 from "../Asserts/personalloan2.png";
import carloan from "../bank/carloan.png";
import indian from "../Asserts/indian.jpg";
import images from "../Asserts/images.png";

const loanData = [
  { title: "Home Loan", icon: homeloan, description: "Your Dream Home Awaits Explore the Best Home Loan Deals Compare Multiple Lenders & Interest Rates Quick Approvals with Minimal Hassle" },
  { title: "Personal Loan", icon: personalloan2, description: "Achieve Your Dreams With Our Versatile Personal Loan Options Low Interest Rates & Quick Approvals Minimal Documentation, Maximum Convenience" },
  { title: "Business Loan", icon: personalloan, description: "Boost Your Business Growth With Our Flexible Financing Options Quick Approvals & Competitive Rates Tailored Solutions for Your Success" },
  { title: "Car loan", icon: carloan, description: "Drive Your Dream Car With Our Quick & Flexible Car Loans Low Interest Rates & Easy EMIs Fast Approvals, Hassle-Free Process" },
  { title: "Gold loan", icon: indian, description: "Turn Your Gold into Instant Cash With Our Quick & Secure Gold Loans Low Interest Rates & Flexible Repayment Fast Processing, Maximum Value for You" },
  { title: "Education loan", icon: images, description: "Invest in Your Future Today With Our Easy Education Loans Low Interest Rates & Flexible EMIs Quick Approvals for a Brighter Tomorrow" }



];

const Insurance = [
  { title: "Life Insurance", icon: lifeinsurance, description: "Protect Your Loved Ones' Future With Our Reliable Life Insurance Plans Comprehensive Coverage & Flexible Benefits Secure Tomorrow, Start Today" },
  { title: "Health Insurance", icon: healthinsurance, description: "Secure Your Health, Secure Your Future With Our Comprehensive Health Insurance Plans Affordable Premiums & Extensive Coverage Quick Approvals for Peace of Mind" },
];
function Weoffering() {
  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-3xl font-bold text-left text-[#FF6F00] mb-6">We Facilitate</h2>
      <p className="text-left text-gray-700 mb-8">Wide Range of Financial Products That Suit Your Needs!</p>

      {/* Loan Offerings Section */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {loanData.map((loan, index) => (
          <div key={index} className="rounded-lg p-6 shadow-md bg-white flex flex-col   text-left">
            <img src={loan.icon} alt={loan.title} className="w-16 h-16 mb-4" />
            <h3 className="text-xl font-semibold">{loan.title}</h3>
            <p className="text-gray-600 mt-2">{loan.description}</p>
          </div>
        ))}
      </div>

      {/* Insurance Section */}
      <h2 className="text-3xl font-bold text-left text-[#FF6F00] mt-12 mb-6">Insurance</h2>
      <p className="text-left text-gray-700 mb-8">Comprehensive Coverage for a Secure Future</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {Insurance.map((insurance, index) => (
          <div key={index} className="rounded-lg p-6 shadow-md bg-white flex flex-col text-left">
            <img src={insurance.icon} alt={insurance.title} className="w-16 h-16 mb-4" />
            <h3 className="text-xl font-semibold">{insurance.title}</h3>
            <p className="text-gray-600 mt-2">{insurance.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Weoffering;
